
import { LicenseDetailActions, LicenseDetailActionTypes } from '../actions/license-detail.actions';
import {LicenseMgtDetail} from '../license-mgt.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: LicenseMgtDetail;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(state = initialState, action: LicenseDetailActions): State {
  switch (action.type) {
    case LicenseDetailActionTypes.GetLicenseDetails:
      return {...state, Loaded: false, Loading: true};

    case LicenseDetailActionTypes.LoadLicenseDetails:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case LicenseDetailActionTypes.GetLicenseDetailsFail:
      return {...state, Loaded: true, Loading: false, entities: null};

    default:
      return state;
  }
}
